import { FOOTAGE_FINISHED_MESSAGE, getOverlapingMedia, getPeriodErrorMessage, TIMELAPSE_FINISHED_MESSAGE } from './utils';

import type { Media, MediaRequest, Trip } from '@cobliteam/common-types';

import Link from '@cobliteam/ui/components/Link';
import Typography from '@cobliteam/ui/components/Typography';

import type { MediaRequestData } from '../../types/MediaRequest';

interface MediaAlreadyRequestedBlockProps {
  mediaRequestData?: MediaRequestData;
  medias?: Media[];
  trip?: Trip;
}

const MediaAlreadyRequestedBlock = ({ mediaRequestData, medias, trip }: MediaAlreadyRequestedBlockProps) => {
  const overlapingMedia = getOverlapingMedia(mediaRequestData, medias, trip);
  const errorMessage = getPeriodErrorMessage(mediaRequestData, medias, trip);
  if (errorMessage === undefined) return null;

  const finishedRequestMessages = [TIMELAPSE_FINISHED_MESSAGE, FOOTAGE_FINISHED_MESSAGE];
  if (finishedRequestMessages.includes(errorMessage)) {
    const videoLink = `https://painel.cobli.co/camera/requests?id=${overlapingMedia?.id}`;

    return (
      <div className='max-w-52'>
        <Typography variant='caption-default' color='secondary'>
          {errorMessage}{' '}
          <Link size='sm' href={videoLink} target='_blank' rel='noopener noreferrer' className='font-normal text-primary text-xs hover:text-primary focus:text-primary'>
            Acessar vídeo
          </Link>
        </Typography>
      </div>
    );
  }

  const requestDetails = overlapingMedia?.mediaDetails as MediaRequest | undefined;
  const triggerRequestSuffix = requestDetails?.triggerId ? 'Confira na aba "Solicitados automaticamente”.' : '';

  return (
    <Typography variant='caption-default' color='secondary'>
      {errorMessage} {triggerRequestSuffix}
    </Typography>
  );
};

export default MediaAlreadyRequestedBlock;
